import React from 'react'
import { clearBusChassis, getBusChassis, putBusChassis } from "../../../../actions";
import { BUS_CHASSIS_PATH } from "../../../../config/paths";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import Content from "../../../layout/Content";
import PropTypes from 'prop-types';
import { breadcrumbsPropTypes, matchPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { useLayoutEffect } from 'react';
import BusChassisForm from './BusChassisForm';
import Immutable from 'immutable';
import { connect } from 'react-redux';

const EditBusChassis = ({
    breadcrumbs,
    dispatchGetBusChassis,
    dispatchClearBusChassis,
    dispatchPutBusChassis,
    match: {
        params: { id: busChassisId },
    },
    loading,
    endpoint,
}) => {
    useLayoutEffect(() => {
        dispatchGetBusChassis({ busChassisId });

        return () => dispatchClearBusChassis();
    }, []);

    const onSubmit = (formValues) => {
        const newFormValues = { ...formValues };

        dispatchPutBusChassis(busChassisId, newFormValues);
    };

    const generateInitialValues = ({
        make,
        model,
        year,
        numberOfAxles
    }) => {
        return {
            make,
            model,
            year,
            numberOfAxles
        };
    };

    let content;

    if (loading) content = <Loader />;
    else if (endpoint.isEmpty())
        content = <NoDataResource returnPage={BUS_CHASSIS_PATH} />;
    else
        content = (
            <BusChassisForm
                onSubmit={onSubmit}
                initialValues={generateInitialValues(endpoint.toJS())}
            />
        );

    return (
        <Content
            breadcrumbs={breadcrumbs}
            title="Editar Chasís"
            subtitle="Editar Chasís"
            content={content}
        />
    );
};

EditBusChassis.propTypes = {
    breadcrumbs: breadcrumbsPropTypes.isRequired,
    dispatchClearBusChassis: PropTypes.func.isRequired,
    dispatchGetBusChassis: PropTypes.func.isRequired,
    dispatchPutBusChassis: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    match: matchPropTypes.isRequired,
    endpoint: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditBusChassis.defaultProps = {
    loading: false,
};

const mapDispatchToProps = {
    dispatchClearBusChassis: clearBusChassis,
    dispatchGetBusChassis: getBusChassis,
    dispatchPutBusChassis: putBusChassis,
};

const mapStateToProps = (
    { BusUnit },
    {
        match: {
            params: { id },
        },
    },
) => ({
    breadcrumbs: [
        ...BusUnit.UnitHome.get('breadcrumbs'),
        {
            text: 'Chasís',
            href: BUS_CHASSIS_PATH,
        },
        {
            text: 'Ver',
            href: `${BUS_CHASSIS_PATH}/${id}`,
        },
        {
            text: 'Editar',
            href: '',
        },
    ],
    endpoint: BusUnit.BusChassis.getIn(['current', 'content']),
    loading: !BusUnit.BusChassis.getIn([
        'current',
        'activity',
    ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditBusChassis);
